<template>
  <v-navigation-drawer location="right" expand-on-hover rail>
    <!-- Running Log Dialog -->
    <v-dialog max-width="50%" max-height="50%" scrollable>
      <template v-slot:activator="{ props: activatorProps }">
        <v-list-item 
          v-bind="activatorProps" 
          link 
          title="Show running log" 
          prepend-icon="mdi mdi-math-log"
          @click="showRunningLog"
        ></v-list-item>
      </template>
      <template v-slot:default="{ isActive }">
        <v-card title="Running log">
          <v-card-text>
            <li v-for="(line, index) in runningLogText" :key="index">{{ line }}</li>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text="Close Dialog" @click="isActive.value = false"></v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    
    <!-- Commands Dialog -->
    <v-dialog max-width="50%" max-height="50%" scrollable>
      <template v-slot:activator="{ props: activatorProps }">
        <v-list-item 
          v-bind="activatorProps" 
          link 
          title="Show Python commands" 
          prepend-icon="mdi mdi-console-line"
          @click="showCommands"
        ></v-list-item>
      </template>
      <template v-slot:default="{ isActive }">
        <v-card title="Python command">
          <v-card-text>
            <v-textarea readonly v-model="commandText"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text="Close Dialog" @click="isActive.value = false"></v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ToolsNavigationDrawer',
  data() {
    return {
      runningLogText: [],
      commandText: '',
      maxLogLines: 100 // 最大日志行数
    };
  },
  methods: {
    // 添加步骤成功日志
    addStepLog(stepName, status = 'success') {
      const timestamp = new Date().toLocaleTimeString();
      const logEntry = `[${timestamp}] Step ${stepName}: ${status}`;
      
      // 添加新日志到开头
      this.runningLogText.unshift(logEntry);
      
      // 如果超过最大行数，删除最旧的日志
      if (this.runningLogText.length > this.maxLogLines) {
        this.runningLogText = this.runningLogText.slice(0, this.maxLogLines);
      }
    },
    
    // 添加自定义日志
    addCustomLog(message, status = 'info') {
      const timestamp = new Date().toLocaleTimeString();
      const logEntry = `[${timestamp}] ${message}: ${status}`;
      
      // 添加新日志到开头
      this.runningLogText.unshift(logEntry);
      
      // 如果超过最大行数，删除最旧的日志
      if (this.runningLogText.length > this.maxLogLines) {
        this.runningLogText = this.runningLogText.slice(0, this.maxLogLines);
      }
    },
    
    // 清空日志
    clearLog() {
      this.runningLogText = [];
    },

    async showRunningLog() {
      // 不再从API获取日志，直接显示本地日志
      // 如果需要从API获取，可以保留原来的逻辑
    },

    async showCommands() {
      try {
        const response = await axios.get('/exposome/RCommand', {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        this.commandText = response.data;
        console.log('命令文本:', this.commandText);
      } catch (error) {
        console.error('获取命令失败:', error);
      }
    }
  }
};
</script>

<style scoped>
/* 如果需要特定样式可以在这里添加 */
</style>
